import { render, staticRenderFns } from "./InterfaceFee.vue?vue&type=template&id=7c22c8dc&scoped=true"
import script from "./InterfaceFee.vue?vue&type=script&lang=js"
export * from "./InterfaceFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22c8dc",
  null
  
)

export default component.exports